import Hr from './component'

export default Hr
